const inFlightMap = new Map();

export default {
    get(key) {
        return inFlightMap.get(key);
    },
    set(key, promise) {
        inFlightMap.set(key, promise);
    },
    delete(key) {
        inFlightMap.delete(key);
    },
    has(key) {
        return inFlightMap.has(key);
    }
};